<template>
  <div>
    <div class="section-base report-filter padded elevated-0 bordered">
      <div class="report-filter__filters">

        <Input v-if="filterByStoreOrOrg && isGlobalAdmin"
          :model="selectedReportFor"
          :isEdit="true"
          @updateModel="selectedReportFor = $event"
          :inputData="{
            id: 'filterByStoreOrOrg',
            placeholder: 'Store or Org',
            type: 'select',
            label: 'name',
            options: reportFor
          }"
         />

         <Input v-if="filterBySaleType"
          :model="selectedReportSaleType"
          :isEdit="true"
          @updateModel="selectedReportSaleType = $event"
          :inputData="{
            id: 'selectedReportSaleType',
            placeholder: 'Sale Type',
            type: 'select',
            label: 'name',
            options: getReportSaleType
          }"
        />

        <Input v-if="filterByItemLocation"
          :model="selectedReportItemLocation"
          :isEdit="true"
          @updateModel="selectedReportItemLocation = $event"
          :inputData="{
            id: 'filterByItemLocation',
            placeholder: 'Location',
            type: 'select',
            label: 'name',
            options: reportItemLocation
          }"
        />

        <Input v-if="filterByItemType"
          :model="selectedReportItemType"
          :isEdit="true"
          @updateModel="selectedReportItemType = $event"
          :inputData="{
            id: 'filterByItemType',
            placeholder: 'Type',
            type: 'select',
            label: 'name',
            options: reportItemType
          }"
         />

         <Input v-if="filterByMemoType"
          :model="selectedReportMemoType"
          :isEdit="true"
          @updateModel="selectedReportMemoType = $event"
          :inputData="{
            id: 'filterByMemoType',
            placeholder: 'Type',
            type: 'select',
            label: 'name',
            options: reportMemoType
          }"
         />

        <Input v-if="filterByCustomerLoyalty"
          :model="selectedReportCustomerLoyalty"
          :isEdit="true"
          @updateModel="selectedReportCustomerLoyalty = $event"
          :inputData="{
            id: 'filterByCustomerLoyalty',
            placeholder: 'Type',
            type: 'select',
            label: 'name',
            options: reportCustomerLoyalty
          }"
         />

        <Input v-if="filterByAllThis"
          :model="selectedReportAllThis"
          :isEdit="true"
          @updateModel="selectedReportAllThis = $event"
          :inputData="{
            id: 'filterByAllThis',
            placeholder: 'Select',
            type: 'select',
            label: 'name',
            options: reportAllThis
          }"
         />

        <Input v-if="filterByText"
          :model="filterText"
          :isEdit="true"
          @updateModel="filterText = $event"
          :inputData="{
            placeholder: filterTextPlaceHolder,
            type: 'input',
          }"
         />

        <Input v-if="filterByRange"
          :model="filterRange.from"
          :isEdit="true"
          @updateModel="filterRange.from = $event"
          :inputData="{
            placeholder: filterByRangePlaceholderFrom,
            type: 'input',
          }"
        />

        <Input v-if="filterByRange"
          :model="filterRange.to"
          :isEdit="true"
          @updateModel="filterRange.to = $event"
          :inputData="{
            placeholder: filterByRangePlaceholderTo,
            type: 'input',
          }"
        />

        <Input v-if="filterByDateFromOnly"
          :model="selectedPeriod.from"
          :isEdit="true"
          @updateModel="selectedPeriod.from = $event"
          :inputData="{
            id: 'from',
            placeholder: 'From',
            type: 'calendar',
            dateFormat: 'dd/mm/yyyy',
            showTime: false,
          }"
         />

        <Input v-if="filterByTime"
          :model="selectedPeriod.from"
          :isEdit="true"
          @updateModel="selectedPeriod.from = $event"
          :inputData="{
            id: 'from',
            placeholder: 'From',
            type: 'calendar',
            dateFormat: 'dd/mm/yyyy',
            showTime: false,
          }"
         />

        <Input v-if="filterByTime"
          :model="selectedPeriod.to"
          :isEdit="true"
          @updateModel="selectedPeriod.to = $event"
          :inputData="{
            id: 'to',
            placeholder: 'To',
            type: 'calendar',
            dateFormat: 'dd/mm/yyyy',
            showTime: false,
          }"
         />

         <Input v-if="filterByTimeAsOf"
          :model="selectedPeriod.from"
          :isEdit="true"
          @updateModel="selectedPeriod.from = $event"
          :inputData="{
            id: 'from',
            placeholder: 'From',
            type: 'calendar',
            dateFormat: 'dd/mm/yyyy',
            showTime: false,
          }"
         />

        <div
          v-if="filterButtons && filterButtons.length > 0"
          class="filter-buttons-container"
        >
          <inline-button
            :type="filterButton.isSelected ? 'primary' : 'plain-primary'"
            @click="() => emitFilterButtonClick(filterButton)"
            v-for="filterButton in filterButtons"
            :key="filterButton._id"
            :label="filterButton.label"
          />
        </div>

        <BaseBtn
          @click="submit"
          label="Submit"
          size="sm"
          :disabled="isLoading"
          :isLoading="isLoading"
          style="align-self: center; margin-top: .25rem;"
        />
      </div>
    </div>
    <div class="percentage-bar">
      <div
        v-if="percentage != 100"
        class="percentage-bar__value"
        :style="{ width: `${percentageBar}` }"
      ></div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import BaseBtn from "@/components/Base/Button/Button.vue";
import Input from "@/components/Input/Input.vue";
import { mapActions, mapGetters } from "vuex";
import {
  globalAdminRoles
} from "@/constants/roles";

export default {
  name: "EntityFilter",
  data() {
    return {
      selectedPeriod: {
        from: new Date(new Date().setDate(new Date().getDate() - 7)),
        to: new Date(),
      },
      filterRange: {
        from: "",
        to: "",
      },
      selectedReportFor: "store",
      reportFor: [
        { name: "Store", code: "store" },
        { name: "Organization", code: "organization" },
      ],
      selectedReportSaleType: "",

      selectedReportItemLocation: "working inventory",
      reportItemLocation: [
        { name: "working inventory", code: "working inventory" },
        { name: "store", code: "store" },
      ],

      selectedReportItemType: "cannabis",
      reportItemType: [
        { name: "all", code: "all" },
        { name: "cannabis", code: "cannabis" },
        { name: "non-cannabis", code: "non-cannabis" },
      ],

      selectedReportMemoType: "all",
      reportMemoType: [
        { name: "all (no gift cards)", code: "all" },
        { name: "cash mistake", code: "cashMistake" },
        { name: "ccp", code: "ccp" },
        { name: "disposal", code: "disposal" },
        { name: "gift card", code: "giftCard" },
        { name: "points", code: "point" },
        { name: "promotion", code: "promotion" },
        { name: "refund", code: "refund" },
        { name: "reward", code: "reward" },
      ],

      selectedReportAllThis: "this",
      reportAllThis: [
        { name: "This Record", code: "this" },
        { name: "All Records", code: "all" },
      ],

      selectedReportCustomerLoyalty: "ccp",
      reportCustomerLoyalty: [
        { name: "ccp", code: "ccp" },
        { name: "discount", code: "discount" },
        { name: "employee", code: "employee" },
        { name: "loyalty", code: "loyalty" },
        { name: "veteran", code: "veteran" },
        { name: "clutch", code: "clutch" },
      ],
      // multiSaleTypeStore is true only if the store is med and rec
      multiSaleTypeStore: false,
      filterText: "",
      filterBtnValue: "",
    };
  },
  props: {
    filterButtons: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    filterByTime: {
      default: false,
    },
    filterByTimeAsOf: {
      default: false,
    },
    filterByText: {
      default: false,
    },
    filterTextPlaceHolder: {
      type: String,
      default: "Search",
    },
    filterByRange: {
      type: Boolean,
      default: false,
    },
    filterByRangePlaceholderFrom: {
      type: String,
      default: "Search From",
    },
    filterByRangePlaceholderTo: {
      type: String,
      default: "Search To",
    },
    filterByStoreOrOrg: {
      type: Boolean,
      default: true,
    },
    filterBySaleType: {
      type: Boolean,
      default: false,
    },
    filterByItemLocation: {
      type: Boolean,
      default: false,
    },
    filterByCustomerLoyalty: {
      type: Boolean,
      default: false,
    },
    filterByAllThis: {
      type: Boolean,
      default: false,
    },
    filterByItemType: {
      type: Boolean,
      default: false,
    },
    filterByMemoType: {
      type: Boolean,
      default: false,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    initialSelectedPeriod: {
      type: Object,
    },
    triggerFilterOnLoad: {
      type: Boolean,
      default: false,
    },
    filterByDateFromOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseBtn,
    Input,
  },
  watch: {
    currentStore(store) {
      this.setDefaultReportSaleType(store);
    },
    selectedReportSaleType(selectedReportSaleType) {
      this.setSaleType(selectedReportSaleType);
    },
  },
  created() {
    if (this.initialSelectedPeriod) {
      this.selectedPeriod = this.initialSelectedPeriod;
    }
    if (this.triggerFilterOnLoad) {
      this.submit();
    }
  },
  mounted() {
    this.setDefaultReportSaleType(this.currentStore);
  },
  computed: {
    ...mapGetters({
      currentStore: "storeModule/currentStore",
      getRole: 'loginModule/role'
     }),
    percentageBar() {
      if (!this.percentage) return `${0}%`;
      return `${this.percentage}%`;
    },
    isGlobalAdmin() {
      return globalAdminRoles.includes(this.getRole);
    },
    getReportSaleType() {
      if (
        (this.currentStore.isMedical && this.currentStore.isRecreational) ||
        this.selectedReportFor == "organization"
      ) {
        return [
          {
            name: "medical and recreational",
            code: "medical and recreational",
          },
          { name: "medical", code: "medical" },
          { name: "recreational", code: "recreational" },
        ];
      }
      if (this.currentStore.isMedical) {
        return [{ name: "medical", code: "medical" }];
      }
      if (this.currentStore.isRecreational) {
        return [{ name: "recreational", code: "recreational" }];
      }
      return [
        { name: "medical and recreational", code: "medical and recreational" },
        { name: "medical", code: "medical" },
        { name: "recreational", code: "recreational" },
      ];
    },
  },
  methods: {
    ...mapActions({
      setMessage: "setMessage",
      setSaleType: "reports/setSaleType",
    }),
    clicked() {
      this.$emit("click");
      if (this.to && !this.disabled) {
        router.push(this.to);
      }
    },
    emitFilterButtonClick(filterButton) {
      this.filterBtnValue = filterButton.name;
      const payload = { filterButton: filterButton };
      this.$emit("filterButtonClicked", payload);
    },
    validatePeriod(period) {

      if(!period.from || !period.to) {
        this.setMessage({
          title: "Date error",
          text: `Please select both "From" and "To" dates`,
          type: "error",
        });
        return false;
      }

      if (period.from > period.to) {
        this.setMessage({
          title: "Date error",
          text: `"From" date can't be grater then "To"`,
          type: "error",
        });
        return false;
      }
      return true;
    },
    validateFilterText() {
      if (!this.filterText.trim()) return false;
      return true;
    },
    validateFilterRange() {
      this.filterRange.from = this.filterRange.from.trim();
      this.filterRange.to = this.filterRange.to.trim();
      if (!this.filterRange.from && !this.filterRange.from) return false;

      return true;
    },
    getPayload() {
      let to = new Date(
        new Date(this.selectedPeriod.to).setHours(23, 59, 59, 999)
      );
      const period = {
        from: this.selectedPeriod.from,
        to: to,
      };

      const payload = {
        selectedReportSaleType: this.selectedReportSaleType,
        selectedReportFor: this.selectedReportFor,
      };

      if (this.filterByItemLocation) {
        payload.selectedReportItemLocation = this.selectedReportItemLocation;
      }

      if (this.filterByCustomerLoyalty) {
        payload.selectedReportCustomerLoyalty =
          this.selectedReportCustomerLoyalty;
      }

      if (this.filterByItemType) {
        payload.selectedReportItemType = this.selectedReportItemType;
      }

      if (this.filterByMemoType) {
        payload.selectedReportMemoType = this.selectedReportMemoType;
      }

      if (this.filterByAllThis) {
        payload.selectedReportAllThis =
          this.selectedReportAllThis;
      }

      if (this.filterByTime) {
        const isValid = this.validatePeriod(period);
        if (!isValid) return;
        payload.selectedPeriod = period;
      }

      if (this.filterByTimeAsOf) {
        payload.selectedPeriod = period;
      }

      if (this.filterByDateFromOnly) {
        payload.selectedPeriod = period;
      }

      if (this.$route.query.customerId) {
        this.filterText = this.$route.query.customerId;
        this.filterByText = true;
      }

      if (this.$route.query.productId) {
        this.filterText = this.$route.query.productId;
        this.filterByText = true;
      }

      if (this.$route.query.supplierId) {
        this.filterText = this.$route.query.supplierId;
        this.filterByText = true;
      }

      if (this.$route.query.itemId) {
        this.filterText = this.$route.query.itemId;
        this.filterByText = true;
      }

      if (this.$route.query.inventoryCountId) {
        this.filterText = this.$route.query.inventoryCountId;
        this.filterByText = true;
      }

      if (this.filterByText && this.validateFilterText()) {
        payload.filterText = this.filterText.trim();
      }

      if (this.filterByRange && this.validateFilterRange()) {
        const filterRangeData = {};
        if (this.filterRange.from) {
          filterRangeData.from = this.filterRange.from;
        }
        if (this.filterRange.to) {
          filterRangeData.to = this.filterRange.to;
        }
        payload.filterRange = filterRangeData;
      }

      if (this.filterButton && this.filterBtnValue) {
        payload.extraFilter = this.filterBtnValue;
      }
      return payload;
    },
    setDefaultReportSaleType(store) {
      if (!this.filterBySaleType) {
        return (this.selectedReportSaleType = "medical and recreational");
      }
      if (store.isMedical && store.isRecreational) {
        this.multiSaleTypeStore = true;
        return (this.selectedReportSaleType = "medical and recreational");
      }
      if (store.isMedical) {
        return (this.selectedReportSaleType = "medical");
      }
      if (store.isRecreational) {
        return (this.selectedReportSaleType = "recreational");
      }
    },
    submit() {
      const payload = this.getPayload();
      this.$emit("submit-filter", payload);
    },
  },
};
</script>

<style lang="scss">
@import "./_reportFilter.scss";
</style>
